import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[lDisabled]',
  standalone: true
})
export class Disabled implements AfterViewInit {

  constructor(
    private readonly element: ElementRef,
  ) { }

  @Input()
  public disableType?: 'full' | 'visual' | 'no-visual' | 'hidden' = 'full';

  @Input()
  public set lDisabled(v: boolean) {
    this._lDisabled = v;
    this.define();
  };

  private static readonly OPACITY_CLASS = 'opacity-50';

  private static readonly POINTER_EVENTS_CLASS = 'pointer-events-none';

  private static readonly HIDDEN_CLASS = 'hidden';

  private _lDisabled?: boolean | '' = true;

  public ngAfterViewInit(): void {
    this.define();
  }

  public define(): void {
    if (this._lDisabled === '')
      this._lDisabled = true;

    this.element.nativeElement.classList.remove(
      Disabled.OPACITY_CLASS,
      Disabled.POINTER_EVENTS_CLASS,
      Disabled.HIDDEN_CLASS,
    );

    if (!this._lDisabled)
      return;

    if (this.disableType === 'full') {
      this.element.nativeElement.classList.add(Disabled.OPACITY_CLASS, Disabled.POINTER_EVENTS_CLASS);
    }

    if (this.disableType === 'visual')
      this.element.nativeElement.classList.add(Disabled.OPACITY_CLASS);

    if (this.disableType === 'no-visual')
      this.element.nativeElement.classList.add(Disabled.POINTER_EVENTS_CLASS);

    if (this.disableType === 'hidden')
      this.element.nativeElement.classList.add(Disabled.HIDDEN_CLASS);
  }

}
